import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const CustomToast = ({ type = 'success', message, open, onClose }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon sx={{ color: '#4caf50' }} />;
      case 'error':
        return <ErrorIcon sx={{ color: '#f44336' }} />;
      case 'warning':
        return <WarningIcon sx={{ color: '#ff9800' }} />;
      case 'info':
        return <InfoIcon sx={{ color: '#2196f3' }} />;
      default:
        return <CheckCircleIcon sx={{ color: '#4caf50' }} />;
    }
  };

  const getSeverity = () => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'success';
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={onClose}
        severity={getSeverity()}
        variant="filled"
        icon={getIcon()}
        sx={{
          '& .MuiAlert-message': {
            fontSize: '0.95rem',
            fontWeight: 500,
          },
          '& .MuiAlert-action': {
            paddingTop: 0,
          },
          minWidth: '300px',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomToast;